export const studentInfo =
  "Why it’s perfect for students: \n \n \
🔄 \u00A0 Simple and seamless process: Our platform makes it easy to find other students to swap with. Everything from the first message \
to the final confirmation happens online. \n\n \
🏡 \u00A0 Fully equipped homes: Since you’re swapping with another student, your new home already includes what you need – \
a study desk, Wi-Fi, kitchen essentials, and maybe even a bike. \n\n \
💬 \u00A0 Local insights from your swap partner: Your exchange partner can give you valuable tips about student life, cafés, \
public transport, and the best hidden spots in town. \n\n \
🤝 \u00A0 Build a global network: Make new friends and connections abroad that could open doors for future studies, internships, or career opportunities.";
